import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Link } from 'react-router'

import BillingStore from '../../../stores/billing'
import { isPremium } from '../../../utils/plans'
import { ensureStripeLoaded } from '../../../stripe'


const plans = {
  basic: 'Standard',
  premium: 'Premium',
  essentials: 'Essentials',
  new_premium: 'Premium'
}

const rates = {
  monthly: 'Monthly',
  yearly: 'Yearly'
}

@inject('auth')
@observer
class Billing extends Component {
  state = {
    store: new BillingStore(),
    processing: false,
    processingAddress: false,
    updateCardMessage: null,
    updateAddressMessage: null,
    stripeLoaded: !!window.stripe,
  }

  componentWillMount() {
    this.state.store.loadCustomer()
    this.state.store.loadLicense()
  }

  componentDidMount() {
    this.stripeInterval = ensureStripeLoaded(() => this.setState({ stripeLoaded: true }))
  }

  componentWillUnmount() {
    clearInterval(this.stripeInterval)
  }

  updateCard = e => {
    e.preventDefault()

    const { store } = this.state

    this.setState({ processing: true, updateCardMessage: null, cardError: null })

    this.address.getValue()
        .then((data) => {
          if(!data.complete){
            this.setState({ processing: false, cardError: 'You must enter billing details.' })
          }else {
            window.stripe.createToken(this.card, this.billingCardData())
                .then(({ token, error }) => {
                  if (error) {
                    this.setState({ cardError: error.message })
                  } else {
                    this.card.clear()
                    if (store.license.status.toLowerCase() === 'cancelled') {
                      return store.activateSubscription(token.id).then((billing_result) => {
                        if (billing_result.data.status.toLowerCase() !== 'cancelled') {
                          this.setState({ updateCardMessage: "Your account has been re-activated." })
                        }
                        // to trigger reload of Status
                        this.state.store.loadLicense()
                      })
                    } else {
                      return store.updateSource(token.id)
                    }
                  }
                })
                .then(() => this.setState({ processing: false }))
                .catch(() => {
                  this.setState({ cardError: 'There was a problem saving your card. Please check that it is valid or try again later.' })
                })
          }
        })
        .catch(() => {
          this.setState({ cardError: 'There was a problem saving your card. Please check that it is valid or try again later.'
        })
    })
  }

  updateBillingAddress = e => {
    e.preventDefault()

    this.setState({ processingAddress: true, updateAddressMessage: null, addressError: null })

    this.address.getValue()
        .then((data) => {
          if(!data.complete){
            this.setState({ processingAddress: false, addressError: 'You must enter billing details.' })
          }else {
            this.setState({ processingAddress: true, addressError: null })
            return this.state.store.updateAddress({billing_address: this.billingCustomerData(data)}).then((result) => {
              if(result.data.ok){
                this.setState({ processingAddress: false, updateAddressMessage: "Address has been updated." })
              }
              this.state.store.loadCustomer()
            })
          }
        }).catch(() => {
      this.setState({ processingAddress: false, addressError: 'There was a problem saving your address. Please check that it is valid or try again later.' })
    })
  }

  handleCardRef = el => {
    if (!el) return
    const elements = window.stripe.elements()
    this.card = elements.create('card', {
      hidePostalCode : true,
    })
    this.card.mount(el)
  }

  getBillingAddress() {
    const { store: { customer } } = this.state
    const authUser = this.props && this.props.auth && this.props.auth.user
    const customerBillingAddress = customer && customer.card && customer.card.billing_address
    const authBillingAddress = authUser && authUser.customer_billing_address

    return customerBillingAddress || authBillingAddress || {}
  }

  handleBillingAddressRef = el => {
    if (!el) return
    const billing_address = this.getBillingAddress()

    const elements = window.stripe.elements()
    this.address = elements.create('address',
        {
          mode: 'billing',
          defaultValues: {
            name: billing_address.name || '',
            address: {
              line1: billing_address.line1 || '',
              line2: billing_address.line2 || '',
              city: billing_address.city || '',
              state: billing_address.state || '',
              postal_code: billing_address.postal_code || '',
              country: billing_address.country || 'US'
            }
          }
        })
    this.address.mount(el)
  }
  billingCardData(){
    const billing_address = this.getBillingAddress()
    return {
      name: billing_address.name || '',
      address_line1: billing_address.line1 || '',
      address_line2: billing_address.line2 || '',
      address_city: billing_address.city || '',
      address_state: billing_address.state || '',
      address_zip: billing_address.postal_code || '',
      address_country: billing_address.country || 'US'

    }
  }
  billingCustomerData(data) {
    const address = (data && data.value && data.value.address) || {}
    return {
      name: (data && data.value && data.value.name) || '',
      line1: address.line1 || '',
      line2: address.line2 || '',
      city: address.city || '',
      state: address.state || '',
      postal_code: address.postal_code || '',
      country: address.country || '',
    }
  }

  renderDirectBill() {
    const { store: { customer, license } } = this.state
    if (!customer || !license) return <div className="loading">Loading...</div>

    return <div className="container centered padded billing">
              <div className="panel full padded">
                <h2 className="title">Current Plan</h2>

                <div className="plan">
                  <div>
                    <strong>Plan:</strong> {plans[license.plan]} ({rates[license.rate]})
                    <br />
                    <strong>Status:</strong> {license.status}
                  </div>
                </div>
                <p>Please contact your website developer for customer service with your billing plan.</p>
              </div>
          </div>
  }

  renderStripeBased() {
    const { cardError, addressError, processing, processingAddress, store: { customer, license } } = this.state
    if (!customer || !license) return <div className="loading">Loading...</div>

    return <div className="container centered padded billing">
        <div className="panel full padded">
          <h2 className="title">Current Plan</h2>

          <div className="plan">
            <div>
              <strong>Plan:</strong> {plans[license.plan]} ({rates[license.rate]})
              <br />
              <strong>Status:</strong> {license.status}<br />
              {license.status.toLowerCase() === 'cancelled' && (
                <span>Enter a credit card below to re-activate your subscription.</span>
              )}
            </div>

            {!license.revoked && (
            <div className="current">
              {!isPremium(license.plan) && <Link to="/billing/upgrade" className="button">Upgrade to Premium</Link>}
            </div>
            )}
          </div>
        </div>

        <div className="panel full padded">
          <h2 className="title">Payment Method</h2>

          <div className="payment">
            <div className="current half padded p-10">
              <h4>Current Card</h4>

              <div className={'d-flex flex-between'}>
                <div>
                  &bull;&bull;&bull;&bull;
                  &bull;&bull;&bull;&bull;
                  &bull;&bull;&bull;&bull;
                  {' '}
                  {customer.card.last4}
                </div>
                <div>EXP {customer.card.expiry}</div>
              </div>

              <div>
                <form onSubmit={this.updateCard} >
                  <h4 className={'mt-20'}>Update Your Card</h4>
                  {this.state.stripeLoaded && <div ref={this.handleCardRef} />}
                  <button className="button success block" onClick={this.updateCard} disabled={processing}>
                    <i className="fa fa-credit-card" />
                    &nbsp; Save New Credit Card
                  </button>
                  {processing && <div>Processing card...</div>}
                  {this.state.updateCardMessage && <div>{this.state.updateCardMessage}</div>}
                  {cardError && <div className="error">{cardError}</div>}
                </form>
              </div>
            </div>

            <div className={'half padded p-10'}>
              <form onSubmit={this.updateBillingAddress}>
                <h4>Update Billing Address</h4>
                {this.state.stripeLoaded && <div ref={this.handleBillingAddressRef} />}
                <button className="button success block" onClick={this.updateBillingAddress} disabled={processingAddress}>
                  <i className="fa fa-address-card" />
                  &nbsp; Save Billing Address
                </button>
                {processingAddress && <div>Processing address...</div>}
                {this.state.updateAddressMessage && <div>{this.state.updateAddressMessage}</div>}
                {addressError && <div className="error">{addressError}</div>}
              </form>
            </div>
          </div>
        </div>

        <div className="panel full padded">
          <h2 className="title">Payment History</h2>
          <table className="zebra padded">
            <thead>
              <tr>
                <th>Date</th>
                <th>Amount</th>
                <th>Download</th>
              </tr>
            </thead>
            <tbody>
              {customer.charges.map(charge => (
                <tr key={charge.id}>
                  <td>{charge.created_at}</td>
                  <td>{charge.amount_captured}</td>
                  <td>
                    {charge.stripe_receipt_url && (
                      <a href={charge.stripe_receipt_url} target="_blank">
                        View <i className="fa fa-file-o" />
                      </a>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
    </div>
  }

  renderPaymentInfo() {
    if (this.props.auth.user.license_direct_bill) {
      return this.renderDirectBill()
    } else {
      return this.renderStripeBased()
    }
  }

  render() {
    return this.renderPaymentInfo()
  }
}

export default Billing



// WEBPACK FOOTER //
// client/components/sections/Billing/index.js